import { WrittenNumber } from '@peerless/data-access/strapi';

export function formatPosition(position: string | null) {
  switch (position) {
    case 'Left':
    case 'Top':
      return 'start';
    case 'Center':
    case 'Middle':
      return 'center';
    case 'Right':
    case 'Bottom':
      return 'end';
    default:
      return 'center';
  }
}

export function formatTextPosition(position: string | null) {
  switch (position) {
    case 'Left':
    case 'Top':
      return 'left';
    case 'Center':
    case 'Middle':
      return 'center';
    case 'Right':
    case 'Bottom':
      return 'right';
    default:
      return 'center';
  }
}

export function formatWrittenNumber(writtenNumber: WrittenNumber | undefined) {
  switch (writtenNumber) {
    case 'One':
      return 1;
    case 'Two':
      return 2;
    case 'Three':
      return 3;

    default:
      return 1;
  }
}
